export enum ChangePasswordErrorCauses {
  InvalidCurrentPassword,
  EmptyPassword,
  PasswordStartsOrEndsWithWhitespaces,
  PasswordTheSameAsCurrentOne,
  PasswordTooShort,
  PasswordDoesNotMeetPatternRequirements,
  PasswordWasUsedBefore,
  PasswordIsDateOfBirthBased,
}

export type PasswordRequirementsDto = {
  minimumPasswordLength: number
  requiredSpecialCharactersNumber: number
  requiredLetterCharactersNumber: number
  requiredDigitCharactersNumber: number
}

export type ChangePasswordErrorDetails = {
  errorCausesList: ChangePasswordErrorCauses[]
  passwordRequirements: PasswordRequirementsDto
}
